<template>
  <van-popup v-model="popupShow">
    <div class="association">
      <div class="association-title"></div>

      <div class="association-radio">
        <van-form ref="idForm">
          <van-field
            v-model="form.waisong_date"
            name=""
            label=""
            placeholder="请输入外送预约时间"
          />
        </van-form>
      </div>
      <div class="association-btn">
        <el-button
          size="small"
          type="primary"
          @click="popupShow = false"
        >取消</el-button>
        <el-button
          size="small"
          type="primary"
          @click="submit"
        >确认</el-button>
      </div>
    </div>
  </van-popup>
</template>
  
  <script>
import workService from "@/apis/work/index.js";
import getUserInfo from "@/models/userInfo";
import { Dialog } from "vant";
import { isWeiXin } from "@/utils/utils";
import { Message } from "element-ui";

export default {
  name: "waisongTime",
  props: {
    BasicData: {
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      form: {},
      popupShow: false,
      isWeiXin: isWeiXin(),
      userInfo: {},
    };
  },
  created() {
    this.init();
  },
  methods: {
    submit() {
      const { form } = this;
      if (!form.waisong_date) {
        Message({
          message: "请输入外送预约时间",
          type: "warning",
        });
        return;
      }
      const params = {
        ...form,
        work_id: this.$route.query.id,
        user_id: this.userInfo.user_id,
      };
      workService.workEditWaisongDate(params).then((res) => {
        Message({
          message: "关联成功",
          type: "success",
        });
        this.popupShow = false;
        this.$parent.workMyWorkDetail();
        console.log(res);
      });
    },
    show() {
      this.popupShow = true;
    },
    async init() {
      const { isWeiXin } = this;
      if (isWeiXin) {
        this.userInfo = {
          user_id: this.$route.query.userid,
        };
        return true;
      } else {
        const userInfo = await getUserInfo();
        this.userInfo = userInfo;
        return true;
      }
    },
    goCallRecords() {
      this.$router.push({
        name: "WorkOrderCallRecords",
        query: {
          work_id: this.$route.query.id,
        },
      });
    },
    contactClients() {
      const { BasicData, userInfo } = this;
      Dialog.confirm({
        title: "提示",
        message: "请确认是否联系客户？",
      })
        .then(() => {
          const params = {
            work_id: this.$route.query.id,
            to_user_id: "",
            to_user_name: BasicData.ContactName,
            to_user_phone: BasicData.ContactPhone,
            user_id: userInfo.user_id,
          };
          workService.WorkContactCustomer(params).then((res) => {
            console.log(res);
          });
        })
        .catch(() => {
          // on cancel
        });
    },
  },
};
</script>
  
  <style>
</style>